<template>
    <GChart type="PieChart" :data="chartData" :options="options" />
  </template>
  
  <script>
  import { GChart } from 'vue-google-charts'
  
  export default {
    components: { GChart },
  
    props: { data: Array },
  
    computed: {
      chartData() {
        return [
          ['Category', 'Amount'],
          ...(this.data || []).map(i => [
            i.category,
            Number(i.total)
          ])
        ]
      }
    },
  
    data() {
      return {
        options: { pieHole: 0.4, height: 300 }
      }
    }
  }
  </script>